<template>
<div></div>
</template>

<script>
export default {
  name: "VirtuallyMap",
  inject:['mainObj','componentId','setComponentId'],
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/MeterVirtually/components/virtually/VirtuallyMap.vue